import { useNavigation } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { RootStackParamList } from '../../../navigation/navigationTypes'
import { UseSettingsResult } from './types'

type SettingsNavigationProp = NativeStackNavigationProp<RootStackParamList, keyof RootStackParamList>

export const useSettingsNavigation = (): UseSettingsResult => {
  const navigation = useNavigation<SettingsNavigationProp>()

  return {
    navigation
  }
}
